import { getConfig } from '@/utils/config/config';
import type { RequestContext, RequestInterceptor } from '../../types';
import type { CorePx } from '@fanduel/cpe-um-bundle/core-px/library';

// Core PX module lazy loader
let corePxModulePromise: Promise<{ CorePx: typeof CorePx }> | null = null;
const getCorePx = async () => {
    if (!corePxModulePromise) {
        corePxModulePromise = import('@fanduel/cpe-um-bundle/core-px/library');
    }
    return corePxModulePromise;
};

const getUrlString = (input: RequestInfo | URL): string => {
    if (typeof input === 'string') return input;
    if (input instanceof URL) return input.toString();
    return input.url;
};

export const pxRequestInterceptor: RequestInterceptor = async (ctx: RequestContext, next) => {
    const { init, options } = ctx;
    const url = getUrlString(ctx.input);

    const { domain } = getConfig();
    const apiOrigin = `${domain}/api`;

    // Server-side: skip PX
    if (typeof window === 'undefined' || options?.pxDisabled || !url.includes(`${apiOrigin}`)) {
        return next(ctx);
    }

    // Client-side: add PX headers
    const { CorePx } = await getCorePx();
    const pxHeaders = await CorePx.getRequestHeaders(url);

    const finalInit: RequestInit = {
        ...init,
        headers: {
            ...ctx.init?.headers,
            ...pxHeaders
        }
    };

    return next({ input: ctx.input, init: finalInit, options: ctx.options });
};
